module.exports = __webpack_public_path__ + "img/IMG_1401_L_Wood_MockedUp.025ee538.jpg";